var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccede(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.881,
    height: 63.881,
    viewBox: "0 0 63.881 63.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ab53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36953e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334",
    transform: "translate(-137.959 -1202.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258",
    transform: "translate(137.959 1202.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    transform: "translate(0 0)",
    stroke: "#fff",
    strokeWidth: 3,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.94,
    cy: 31.94,
    r: 31.94,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.94,
    cy: 31.94,
    r: 30.44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(19.904 19.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4913",
    "data-name": "Path 4913",
    d: "M23.245,2.961,14.819,1.084a3.8,3.8,0,0,0-1.565,0L4.829,2.961A3.611,3.611,0,0,0,2,6.488v4.9a16.936,16.936,0,0,0,10.749,15.84,3.37,3.37,0,0,0,1.288.253,3.611,3.611,0,0,0,1.288-.241A16.972,16.972,0,0,0,26.073,11.387v-4.9a3.611,3.611,0,0,0-2.829-3.527Zm-3.491,8.582-5.79,5.693a1.2,1.2,0,0,1-1.7,0l-2.744-2.7a1.2,1.2,0,0,1,1.7-1.709l1.9,1.866,4.947-4.815a1.209,1.209,0,0,1,1.7,1.721Z",
    transform: "translate(-2 -1.002)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccede);
export default __webpack_public_path__ + "static/media/accede.78e115bc9c9acd73061cee45b32a85db.svg";
export { ForwardRef as ReactComponent };